import { useState } from "react";
import { useTranslation } from "react-i18next";
import BlankModal from "components/commons/BlankModal";
import Loading from "components/commons/Loading";
import { useCreateCompanyMutation } from "../api/platformAdminApiSlice";

export default function NewCompanyForm() {
    const [t, i18n] = useTranslation("global");

    // Stato locale per i valori del form
    const [formData, setFormData] = useState({
        name: "",
        vat: "",
        exp: "",
        users: 10,   // Aggiunto valore predefinito per 'users'
        modules: ["CORE"]  // Stato per il multi-select dei moduli
    });


    // API
    const [createCompany, {
        data: createResult,
        isLoading: createIsLoading,
        isSuccess: createSuccess,
        reset: createReset
    }] = useCreateCompanyMutation()

    // Funzione per gestire i cambiamenti negli input
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const resetForm = () => {
        setFormData({
            name: "",
            vat: "",
            exp: "",
            users: 10,
            modules: ["CORE"]
        });
        createReset();
    };

    // Funzione per gestire la selezione multipla dei moduli
    const handleModulesChange = (e) => {
        // Ottieni i moduli selezionati dall'utente
        const selectedModules = Array.from(e.target.selectedOptions, option => option.value);

        // Assicurati che "CORE" sia sempre incluso nell'array dei moduli selezionati
        if (!selectedModules.includes("CORE")) {
            selectedModules.push("CORE");
        }

        // Aggiorna lo stato con i moduli selezionati (incluso "CORE")
        setFormData((prevData) => ({
            ...prevData,
            modules: selectedModules,
        }));
    };

    // Funzione per gestire la sottomissione del form
    const handleSubmit = (e) => {
        e.preventDefault();

        // Conversione della data (exp) da ISO string a timestamp in secondi (epoch)
        const expTimestamp = new Date(formData.exp).getTime();

        const dataToSubmit = {
            ...formData,
            exp: expTimestamp // Sovrascrivi exp con il timestamp in secondi
        };

        console.log("Dati inviati:", dataToSubmit);
        createCompany(dataToSubmit)
    };

    // Contenuto del form con classi Bootstrap 5.3
    let content

    if (createIsLoading) {
        content = <Loading />
    } else if (createSuccess) {
        content = <div className="alert alert-success">
            Company created successfully!<br />
            <button className="btn btn-primary ml-3" onClick={resetForm}>Create another one</button>
        </div>
    } else content = (
        <form onSubmit={handleSubmit} className="text-start">
            <div className="mb-3 row">
                <div className="col-7">
                    <input
                        type="text"
                        className="form-control"
                        id="companyName"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder={t("property.name")}
                        required
                    />
                </div>

                <div className="col">
                    <input
                        type="text"
                        className="form-control"
                        id="vat"
                        name="vat"
                        value={formData.vat}
                        onChange={handleChange}
                        placeholder={t("property.vat")}
                        required
                    />
                </div>
            </div>

            <div className="mb-3 row">
                <div className="col">
                    <label htmlFor="exp" className="form-label">
                        Expiration
                    </label><br />
                    <input
                        type="date"
                        className="date-picker"
                        id="exp"
                        name="exp"
                        value={formData.exp}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="col-2">
                    <label htmlFor="users" className="form-label">
                        Users
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="users"
                        name="users"
                        value={formData.users}
                        onChange={handleChange}
                        placeholder={10}
                        required
                    />
                </div>
            </div>

            <div className="mb-3 row">
                <div className="col-5">
                    <label htmlFor="modules" className="form-label">
                        Moduli
                    </label>
                    <select
                        id="modules"
                        name="modules"
                        className="form-select"
                        multiple
                        value={formData.modules}
                        onChange={handleModulesChange}
                        required
                    >
                        {/* <option value="CORE">CORE</option> */}
                        <option value="HR">HR</option>
                        <option value="WHISTLE">WHISTLE</option>
                        <option value="HEALTH">HEALTH</option>
                        <option value="SAFETY">SAFETY</option>
                        <option value="DEVICES">DEVICES</option>
                    </select>
                </div>
                <div className="col">
                    <label htmlFor="modules" className="form-label">
                        Amministratore
                    </label>
                    <input
                        type="text"
                        className="form-control mb-3"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder={t("property.username")}
                        required
                    />
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={t("property.email")}
                        required
                    />

                </div>
            </div>

            <button type="submit" className="btn btn-primary">
                {t("action.send")}
            </button>
        </form>
    );

    return (
        <BlankModal
            title={t("entity.company")}
            buttonLabel={
                <>
                    <i className="fa-solid fa-circle-plus"></i> {t("action.add")}
                </>
            }
            body={content}
        />
    );
}
